import _objectDestructuringEmpty from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import * as React from 'react';
import { RatiodataFont } from '../ui/icon';
import { GlobalStyles } from '../theme';
import { PrimaryFont } from '../composition/typography';
export var Core = function Core(_ref) {
  _objectDestructuringEmpty(_ref);

  return React.createElement(React.Fragment, null, React.createElement(GlobalStyles, null), React.createElement(RatiodataFont, null), React.createElement(PrimaryFont, null));
};